// import { login, logout } from '@/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'
// import { setUsername, removeUsername} from '@/utils/auth' // 验权
// import { getCache, setCache } from '@/util/cache'
import Cookies from 'js-cookie'
/* eslint-disable */
const user = {
  state: {
    // token: getToken(),
    username: Cookies.get('username'),
    // avatar: '',
    role: Cookies.get('userRole') && Cookies.get('userRole').toLowerCase(),
    user_logo: Cookies.get('logoPath')
    // avatar: '',
    // roles: []
  },

  mutations: {
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    // },
    SET_USERNAME: (state, username) => {
      // setCache('username', username)
      state.username = username
      // console.log('state.username',state.username);
    },
    SET_ROLE: (state, role) => {
      // setCache('role', role)
      state.role = role
    },
    SET_USER_LOGO: (state, user_logo) => {
      // setCache('user_logo', user_logo)
      state.user_logo = user_logo
    },
    // REMOVE_USERNAME: (state) => {
    //   removeCache('username');
    //   state.username = '';
    //   // console.log('state.username',state.username);
    // }
    // SET_AVATAR: (state, avatar) => {
    //   state.avatar = avatar
    // },
    // SET_ROLES: (state, roles) => {
    //   state.roles = roles
    // }
  },

  actions: {
    // SetUser({ commit }, user) {
    //   console.log('new SetUser',user)
    //   commit('SET_USER', user);
    // }

  }
}

export default user
